import { createSlice } from '@reduxjs/toolkit';

const { reducer, actions } = createSlice({
  name: 'stopReport',
  initialState: { items: [] },
  reducers: {
    setItems(state, action) { state.items = action.payload; },
  }
});

export { actions as stopReportActions };
export { reducer as stopReportReducer };
